import {
  Card,
  CardContent,
  CardHeader,
  Collapse,
  Stack,
  TextField,
  Typography,
  Zoom,
} from "@mui/material";
import {LoadingButton} from '@mui/lab'
import { useFormik } from "formik";
import { useState } from "react";
import * as Yup from "yup";
import {useNavigate} from 'react-router-dom';

function ResetPass() {


  const navigate = useNavigate();

  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [error, setError] = useState(null);
  const [otpError, setOtpError] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);

  
  const myForm = useFormik({
    initialValues: {
      username: "",
      pass: "",
      pass2: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Required"),
      pass: Yup.string().required("Required"),
      pass2: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      setLoading(true)
      let parameters = {
        method: "POST",
        url: "http://127.0.0.1:8000/hrm/resetpassword",
        params: values,
      };
      let credentials = {
        username:myForm.values.username,
        password:myForm.values.pass,
      }
      const loader = async (parameters) => {
        let results = {};
        
        const response = await fetch(parameters.url, {
          mode: "cors",
          method: parameters.method,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
        body: new URLSearchParams(credentials) 
        });

        results.status = response.status;
        const fetcher = response.body.getReader();
        let data = [];
        let receivedLength = 0;
        while (true) {
          const { value, done } = await fetcher.read();

          if (done) {
            break;
          }

          data.push(value);
          receivedLength += value.length;
        }
        let chunksAll = new Uint8Array(receivedLength);
        let position = 0;
        for (let chunk of data) {
          chunksAll.set(chunk, position);
          position += chunk.length;
        }
        let result = new TextDecoder("utf-8").decode(chunksAll);

        let finalData = JSON.parse(result);
        results.data = finalData;
        if (results.status === 200) {
          setLoading(false)
          setOpenConfirmation(true);
          setDisabled(true);
        } else {
          setLoading(false)
          setError(results.data.message);
        }
      };
      loader(parameters);
    },
  });

  const otpForm = useFormik({
    initialValues: {
      otp: "",
    },
    validationSchema: Yup.object({
      otp: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      setConfirmLoading(true);
      let parameters = {
        method: "POST",
        url: "http://127.0.0.1:8000/hrm/resetpassword/otp",
        params: values,
      };
      const loader = async (parameters) => {
        let results = {};
        
        const response = await fetch(parameters.url, {
          mode: "cors",
          method: parameters.method,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
        body: new URLSearchParams(parameters.params) 
        });

        results.status = response.status;
        const fetcher = response.body.getReader();
        let data = [];
        let receivedLength = 0;
        while (true) {
          const { value, done } = await fetcher.read();
          if (done) {
            break;
          }
          data.push(value);
          receivedLength += value.length;
        }
        let chunksAll = new Uint8Array(receivedLength);
        let position = 0;
        for (let chunk of data) {
          chunksAll.set(chunk, position);
          position += chunk.length;
        }
        let result = new TextDecoder("utf-8").decode(chunksAll);

        let finalData = JSON.parse(result);
        results.data = finalData;
        if (results.status === 200) {
          setConfirmLoading(false)
          navigate('/', {replace:true})
        } else {
          setConfirmLoading(false)
          setOtpError(results.data.message);
        }
      };
      loader(parameters);
      
    },
  });
  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack display={"flex"} justifyContent={"center"}>
        <Card>
          <CardHeader title={<Typography>Password Reset</Typography>} />

          <CardContent
            sx={{ display: "flex", flexDirection: "column", rowGap: 2 }}
          >
            <form onSubmit={myForm.handleSubmit}>
              <Stack display={"flex"} justifyContent={"center"} rowGap={2}>
                <Stack>
                  <TextField
                    sx={{ borderRadius: 4 }}
                    label="Username"
                    name="username"
                    id="username"
                    type="text"
                    size="small"
                    value={myForm.values.username}
                    onChange={myForm.handleChange}
                    onBlur={myForm.handleBlur}
                  />
                  {myForm.touched.username && myForm.errors.username ? (
                    <Typography variant="body2" color="error">
                      {myForm.errors.username}
                    </Typography>
                  ) : null}
                </Stack>
                <Stack>
                  <TextField
                    sx={{ borderRadius: 4 }}
                    label="New Password"
                    size="small"
                    name="pass"
                    id="pass"
                    type="password"
                    onChange={myForm.handleChange}
                    value={myForm.values.pass}
                    onBlur={myForm.handleBlur}
                  />
                  {myForm.touched.pass && myForm.errors.pass ? (
                    <Typography variant="body2" color="error">
                      {myForm.errors.pass}
                    </Typography>
                  ) : null}
                </Stack>
                {error ? (
                    <Typography variant="body2" color="error">
                      {error}
                    </Typography>
                  ) : null}
                <Stack>
                  <TextField
                    sx={{ borderRadius: 4 }}
                    label="Confirm Password"
                    size="small"
                    name="pass2"
                    id="pass2"
                    type="password"
                    onChange={myForm.handleChange}
                    value={myForm.values.pass2}
                    onBlur={myForm.handleBlur}
                  />
                  {myForm.touched.pass && myForm.errors.pass ? (
                    <Typography variant="body2" color="error">
                      {myForm.errors.pass}
                    </Typography>
                  ) : null}
                </Stack>
                {myForm.values.pass !== myForm.values.pass2 &&
                myForm.touched.pass &&
                myForm.touched.pass2 ? (
                  <Typography variant="body2" color="error">
                    Passwords dot match!
                  </Typography>
                ) : null}
                <LoadingButton
                  sx={{ borderRadius: 4 }}
                  size="small"
                  variant="contained"
                  type="submit"
                  disabled = {disabled}
                  loading = {loading}
                >
                  Reset Password
                </LoadingButton>
              </Stack>
            </form>
            <form onSubmit={otpForm.handleSubmit}>
              <Collapse in={openConfirmation} timeout="auto" unmountOnExit>
                <Stack display={"flex"} justifyContent={"center"} rowGap={2}>
                  <Typography sx={{ fontWeight: "bold" }} variant="body1">
                    Check your mail or phone for verification code.
                  </Typography>
                  <Typography
                    sx={{ fontWeight: "bold" }}
                    variant="body2"
                    color="error"
                  >
                    Do not share with anyone!
                  </Typography>
                  <Stack>
                    <TextField
                      sx={{ borderRadius: 4 }}
                      label="OTP"
                      size="small"
                      name="otp"
                      id="otp"
                      type="password"
                      onChange={otpForm.handleChange}
                      value={otpForm.values.pass}
                      onBlur={otpForm.handleBlur}
                    />
                    {otpForm.touched.otp && otpForm.errors.otp ? (
                      <Typography variant="body2" color="error">
                        {otpForm.errors.otp}
                      </Typography>
                    ) : null}
                  </Stack>
                  {otpError ? (
                      <Typography variant="body2" color="error">
                        {otpError}
                      </Typography>
                    ) : null}
                  <LoadingButton
                    sx={{ borderRadius: 4 }}
                    size="small"
                    variant="contained"
                    type="submit"
                    loading={confirmLoading}
                  >
                    Confirm
                  </LoadingButton>
                </Stack>
              </Collapse>
            </form>
          </CardContent>
        </Card>
      </Stack>
    </Zoom>
  );
}

export default ResetPass;
